let language = {
    "ADDRESS-BOOK-ADD-BUTTON": "New Address",
    "ADDRESS-BOOK-REMOVE-BUTTON": "Remove",

    // TABLE
    "ADDRESS-BOOK-TABLE-HEADER-NAME": "Name",
    "ADDRESS-BOOK-TABLE-HEADER-CONTACT": "Contact",
    "ADDRESS-BOOK-TABLE-HEADER-ADDRESS": "Address",
    "ADDRESS-BOOK-TABLE-HEADER-TAG": "Tag",
    "ADDRESS-BOOK-TABLE-HEADER-OPERATION": "Operation",

    // STATUS
    "ADDRESS-BOOK-STATUS-DEFAULT": "Default",
    "ADDRESS-BOOK-STATUS-BUTTON-SET-DETAULT": "Set Default",

    "ADDRESS-BOOK-EMPTY-TIPS": "Your address book is empty",
    "ADDRESS-BOOK-NEW ADDRESS": "New Address",
    "ADDRESS-BOOK-EDIT-ADDRESS": "Edit Address",
    "ADDRESS-BOOK-NEWADDRESS": "Add",
    "ADDRESS-BOOK-EDIT": "Edit",

    // DETAIL BUTTON
    "ADDRESS-BOOK-DETAIL-CANCEL-BUTTON": "Cancel",
    "ADDRESS-BOOK-DETAIL-SAVE-BUTTON": "Save",
    
};

export { language }